require('../../common/jv.i18n');
require('../../common/directives/jv.HideOnBlur');
require('../../common/directives/jv.linear-meter.directive.js');
require('../../common/jv.Loading');
require('../../common/directives/jv.ShowPosition');
require('./jv.search.next-workflow.service');
require('../jv.candidates.service');

angular.module('jv.search.grid.directive', [
    'jv.Common.i18n',
    'jv.Common.Directives.HideOnBlur',
    'jv.common.linear-meter.directive',
    'jv.Common.Loading',
    'jv.Common.Directives.ShowPosition',
    'jv.search.next-workflow.service',
    'jv.candidates.service',
    'jv.Common.Filters',
    'jv.Hire.Url.Service'
])
.controller('jvSearchGridController', [
    '$scope', '$rootScope','candidates','i18n','$timeout','jvContextualLoadingService', '$interpolate', 'jvNextWorkflow','jvHireUrlService', '$window', 'jvCandidatesService','$sce',
    function($scope, $rootScope, candidates, i18n, $timeout, jvContextualLoadingService, $interpolate, jvNextWorkflow,jvHireUrlService, $window, jvCandidatesService, $sce) {
        var quickViewInitialized = false;
        $scope.isNewJQuery = parseFloat(jQuery.fn.jquery) > 1.7;
        $scope.jvUrls = jvUrls;
        $scope.i18n = i18n;
        $scope.rank = [i18n.RANK_V_WEAK, i18n.RANK_V_WEAK, i18n.RANK_WEAK, i18n.RANK_AVG, i18n.RANK_STRONG, i18n.RANK_V_STRONG];
        var state = $scope.state = {
            selectAll: false
        };
        $scope.showLinkedInPopUp = false;
        var reqScoreTemplate = $interpolate(i18n.REQ_RANK_SCORE);
        $scope.isfloatingIMWidgetLoaded = false;
        $scope.candidateStickyColumnsAndHeadersEnabled = $window.candidateStickyColumnsAndHeadersEnabled;

        //redirect to candidate details
        $scope.goToCandidateDetail = function(candidate){
            return jvHireUrlService.getApplicationDetailsDefaultTabUrl(candidate.EId);
        };

        $scope.navigateToCandidateDetails = function(candidate){
            $window.location.href = jvHireUrlService.getApplicationDetailsDefaultTabUrl(candidate.EId);
        };

        //show quick view
        $scope.quickView = function(candidate,index, isApplyConnectProfileEnabled) {
            var data = {};
            data.id = candidate.EId;
            if(index === 0){
                data.prev = -1;
            }
            if(index === $scope.results.length-1){
                data.next = -1;
            }
            var jv = window.jv;

            if ($scope.isNewJQuery) {
                jv.modalNew.init(data, 'jv-modalDialog', quickViewInitialized);
            } else {
                jv.modal.init(data, 'jv-modalDialog', quickViewInitialized);
            }
            candidate.isRead = true;
            $scope.currentQuickViewAppEId = data.id;
            $scope.currentQuickViewApp = candidate;
            $rootScope.linkedInAcSource = candidate.source && candidate.source.includes('LinkedIn Apply Connect') ? true : false;
            JV.Person = {
                makeCallForQuickViewOverlayForApplication: function(appId) {
                    var ev = window.event || window.Event;
                    if(ev.preventDefault) {
                        ev.preventDefault();
                    } else {
                        //IE
                        ev.returnValue = false;
                    }
                    $scope.quickView({'EId': appId});
                }
            };

            var paginateQuickView = function(dir){
                for(var i=0 ; i < $scope.results.length; i ++){
                    if($scope.currentQuickViewAppEId === $scope.results[i].EId){
                        var nextEId,nextIndex;
                        if(dir === 'NEXT'){
                            nextEId = $scope.results[i+1].EId;
                            nextIndex = i+1;
                        }else{
                            nextEId = $scope.results[i-1].EId;
                            nextIndex = i-1;
                        }
                        $scope.quickView({'EId': nextEId},nextIndex);
                        break;
                    }
                }
            };

            if (!quickViewInitialized) {
                //handler for quickview pagination
                const quickViewNagivationClickHandler = function(e) {
                    e.preventDefault();
                    if(e.handled === true) {return false;}
                    e.handled = true;
                    var keyObj = $(this).attr('KEY');
                    var typeObj = $(this).attr('NAVIGATION_TYPE');

                    paginateQuickView(typeObj);
                    return false;
                };
                if ($scope.isNewJQuery) {
                    $(document).on('click', '.jv-quickViewNavigation', quickViewNagivationClickHandler);
                } else {
                    $('.jv-quickViewNavigation').live('click', quickViewNagivationClickHandler);
                }

                //handler for change status from quickview
                const tooltipOverlayActionClickHandler = function() {
                    var key = $(this).attr('KEY');
                    switch (key) {
                        case 'rejectFormOverlay':
                            $scope.triggerBulkAction($scope.currentQuickViewApp, null,'REJECT', true);
                            break;
                        case 'getSubmitToHiringManagerForm':
                            $scope.triggerBulkAction($scope.currentQuickViewApp, null,'SUBMIT_HM_MODAL_CLICKED', true, $(this).attr('candidatestateid'));
                            break;
                        case 'offerRejected':
                            $scope.triggerBulkAction($scope.currentQuickViewApp, null,'OFFER_REJECTED_CLICKED', true, $(this).attr('candidatestateid'));
                            break;
                        case 'proceedToForm':
                            $scope.triggerBulkAction($scope.currentQuickViewApp, null,'CHANGE_STATUS', true, $(this).attr('next_state_id'));
                            break;
                        case 'schedulePage':
                            var candidateStateObject = {
                                applicationId: $(this).attr('appid'),
                                stateId: $(this).attr('candidatestateid'),
                                jobId: $(this).attr('jobid'),
                                mode: 'schedule'
                            };
                            $scope.$emit('showScheduler', candidateStateObject);
                            break;
                        default:
                            // do nothing;
                    }
                };
                if ($scope.isNewJQuery) {
                    $(document).on('click', '.jv-tooltipOverlayAction', tooltipOverlayActionClickHandler);
                } else {
                    $('.jv-tooltipOverlayAction').live('click', tooltipOverlayActionClickHandler);
                }
            }
            quickViewInitialized = true;
            if(isApplyConnectProfileEnabled && $rootScope.linkedInAcSource){
                            $rootScope.showLinkedInProfileIntegration=true;
                            candidates.getContactId(candidate.candidateEId, function(response){
                                var contact =  response.resultList[0];
                                $scope.contactEId = contact.EId;
                                var acUrl = $window.jvUrls.jhire + '/modules/candidates/LIAcFrame.html?applicationId=' + $scope.currentQuickViewAppEId + '&contactEid=' + $scope.contactEId;
                                $rootScope.liAcFrameurl = $sce.trustAsResourceUrl(acUrl);
                            });
            }

        };

        $rootScope.refreshLinkedInSync = function() {
                         var contactId=$scope.contactEId;
                         var applicationId = $scope.currentQuickViewAppEId;
                         jvCandidatesService.syncCandidateToLinkedIn({
                              contactEid: contactId,
                              applicationId:applicationId
                             },function(result){
                              if(result) {
                                   angular.forEach(result, function(syncDetails) {
                                       if( syncDetails && syncDetails.syncStatus && syncDetails.type === 'LINKEDIN_ONE_CLICK_EXPORT' ){
                                           $rootScope.oneClickExportLastSyncDate = syncDetails.syncStatus.syncedOn;
                                           $rootScope.showLinkedInSyncErrorIcon = !syncDetails.syncStatus.success;
                                       }
                                   });
                               }
                          });
                    };

        $scope.openJVIMWidget = function(candidateEId){
            jvHireUrlService.openJVIMFloatingWidget(candidateEId, window._jvselfUser.email);
        };

        $scope.sortClass = function(field, classPrefix) {
            var sortBy = $scope.sortBy;
            if (sortBy && sortBy[0] && sortBy[0].fieldId === field) {
                return classPrefix + $scope.order;
            }
        };

        $scope.sort = function(fieldId) {
            $scope.onSort({ fieldId: fieldId });
        };

        $scope.pageSize = 5;

        //get other applications for a given appEId
        $scope.paginateOtherApplications = function(app, pageNumber){
            app.currentPage = pageNumber;
            var applicationEId = app.EId;
            var forceRefresh = true;
            if(app.showOtherApplications){
                $scope.otherApplications({ applicationEId: applicationEId , pageNumber: pageNumber, forceRefresh : forceRefresh});
            }
        };

        $scope.toggleOtherApplicationsList = function(app, pageNumber){
            app.showOtherApplications = !app.showOtherApplications;
            app.currentPage = pageNumber;
            var applicationEId = app.EId;
            var forceRefresh = true;
            if(app.showOtherApplications){
                $scope.otherApplications({ applicationEId: applicationEId , pageNumber: pageNumber,forceRefresh : forceRefresh});
            }
        };

        $scope.cardedView = {
            bulkactionsMap : {},
            parentAppDropdown: {},
            otherAppDropdown: {}
        };
        //set up bulk actions for each application in the carded view
        $scope.setUpbulkAction = function(bulkActions){
            var actions = angular.copy(bulkActions);
            angular.forEach($scope.results,function(application,key){
                var appEId = application.EId;
                jvContextualLoadingService.hide(appEId);
                $scope.cardedView.bulkactionsMap[appEId] = actions;
                if (application.workHistory) {
                    var workHistoryList = [];
                    angular.forEach(application.workHistory, function(workHistory, key) {
                        workHistoryList.push(workHistory['companyName']);
                    });
                    $scope.results[key].employment = workHistoryList.join(', ');
                }
            });
        };

        $scope.hideParentAppDropdown = function(appEId){
                $scope.cardedView.parentAppDropdown[appEId] = false;
        };

        $scope.toggleParentAppDropdown = function(appEId){
            $scope.cardedView.parentAppDropdown[appEId] = ! $scope.cardedView.parentAppDropdown[appEId];
        };

        $scope.hideOtherAppDropdown = function(parentAppEId, appEId){
                var key = parentAppEId+appEId;
                $scope.cardedView.otherAppDropdown[key] = false;
        };
        //toggle bulk actino drop down for apps in the other application list
        $scope.toggleOtherAppDropdown = function(parentAppEId, appEId, reset){
            if(reset){
                $scope.cardedView.otherAppDropdown = {};
            }
            var key = parentAppEId+appEId;
            $scope.cardedView.otherAppDropdown[key] = ! $scope.cardedView.otherAppDropdown[key];
        };

        //bulk action listener
        $scope.triggerBulkAction = function(app,parentApp,action,single, state){
                var appEId = app.EId;
                var isSingle = single;
                var applicantName = app.candidate ? app.candidate.firstName + app.candidate.lastName: app.fullName;
                //var optionIndex = $scope.cardedView.bulkactionsMap[appEId].selectedOption;
                var reqEId  = app.job ? app.job.EId: app.jobEId;

                if(parentApp){
                    //trigger bulk action from other apps list
                    var parentAppEId = parentApp.EId;
                    var key = parentAppEId+appEId;
                    $scope.cardedView.otherAppDropdown[key] = false;
                }else{
                     $scope.cardedView.parentAppDropdown[appEId] = false;
                }
                if(action){
                    action = action? action : $scope.cardedView.bulkactionsMap[appEId].sortOptions[optionIndex].action;
                    $scope.bulkActionCallback({action: action, appEId: appEId, parentAppEId: parentAppEId ,reqEId: reqEId , applicantName:applicantName, isSingle: isSingle, status: state});
                }
                if (state || action === 'REJECT') {
                    $('.jv-closeModalDialog').click();
                }
                //$scope.cardedView.bulkactionsMap[appEId].selectedOption = -1;
        };

        $scope.triggerNextWorkflow = function(result, action) {
            var candidateStateObject = {};
            if (action.predefinedKind === 'REJECTED') {
                $scope.triggerBulkAction(result, null, 'REJECT', true);
            } else if(action.predefinedKind === 'SUBMITTED_TO_HIRING_MANAGER') {
               $scope.triggerBulkAction(result, null,'SUBMIT_HM_MODAL_CLICKED', true, action.EId);
            } else if(action.kind === 'INTERVIEW' && action.actionKind === 'SCHEDULE_INTERVIEW') {
                candidateStateObject = {
                    applicationId: result.EId,
                    stateId: action.EId,
                    jobId: result.jobEId,
                    mode: 'schedule'
                };
                $scope.$emit('showScheduler', candidateStateObject);
            } else if(action.kind === 'INTERVIEW' && action.actionKind === 'GOODTIME') {
                window.open($window.goodTimeUrl.format(result.EId, result.candidateEId,result.candidateState.EId), '_blank');
            } else if(action.kind === 'INTERVIEW' && action.actionKind === 'REQUEST_CANDIDATE_AVAILABILITY') {
                candidateStateObject = {
                    applicationId: result.EId,
                    stateId: action.EId,
                    jobId: result.jobEId,
                    mode: 'schedule'
                };
                $scope.$emit('requestAvailability', candidateStateObject);
            } else if (action.predefinedKind === 'OFFER_REJECTED' && $window.properties.offerDispositionFormEnabled) {
                $scope.triggerBulkAction(result, null, 'OFFER_REJECTED_CLICKED', true, action.EId);
            } else if(action.predefinedKind === 'PENDING_APPROVAL') {
               window.location.href = $scope.jvUrls.forum +'Hiring/OfferManagement.aspx?a=' +result.EId;
            } else if(action.predefinedKind === 'OFFER_ACCEPTED') {
               window.location.href = $scope.jvUrls.jhire +'/modules/requisitions/addHire_close.html#/offerAccept/' +result.EId+'/'+action.EId;
            } else {
                $scope.triggerBulkAction(result, null, 'CHANGE_STATUS', true, action.name);
            }
        };

        $scope.getCeil = function(num){
            if(num == null){
                return null;
            }
            return Math.ceil(num);
        };

        $scope.showRankScoreTooltip = function(id, score) {
            state.showRankScoreTooltip = true;
            state.rankScoreTooltipPosition = {
                my: 'center top',
                at: 'center bottom+5',
                of: id
            };
            state.rankScoreTooltipMessage = score != null ? $scope.rank[$scope.getCeil(score)] : i18n.PENDING;
        };

        $scope.hideRankScoreTooltip = function() {
            state.showRankScoreTooltip = false;
        };

        $scope.showStatusTooltip = function(id, result) {
            // timeout to allow previous tooltip to close on blur
            $timeout(function() {
                state.nextWorkflowActions = null;
                state.showStatusTooltip = true;
                state.activeResult = result;
                state.statusTooltipPosition = {
                    my: 'left top',
                    at: 'left bottom',
                    of: id
                };
                jvNextWorkflow.get(result.EId).then(function(workflowActions) {
                    state.nextWorkflowActions = workflowActions;
                });
            });
        };

        $scope.hideStatusTooltip = function() {
            state.showStatusTooltip = false;
            state.activeResult = null;
        };

        //Making sure results are loaded before setting up bulkactions
        $scope.$watch('results',function(newVal, oldVal){
            if(newVal){
                var bulkActionsConfig  = angular.copy($scope.bulkActions);
                $scope.setUpbulkAction(bulkActionsConfig);
                $timeout(function(){
                    if($window.isfloatingIMWidgetLoaded && !$scope.isfloatingIMWidgetLoaded) {
                        $scope.isfloatingIMWidgetLoaded = window.isfloatingIMWidgetLoaded;
                        $scope.$apply();
                    }
                }, 3000);
            }
        });

        // Added a watch to check if the isfloatingIMWidgetLoaded is true
        // if the JVIM widget is loaded then enable the IM icons
        $scope.$watch(
            function () {
                if($window.isfloatingIMWidgetLoaded && !$scope.isfloatingIMWidgetLoaded) {
                    $scope.isfloatingIMWidgetLoaded = $window.isfloatingIMWidgetLoaded;
                    $timeout(function(){
                        $scope.$apply();
                    });
                }
            }
        );

        // workaround due to ng-if inheriting from parent scope
        // TODO: refactor list view and grid view into separate directives
        $scope.$watch('state.selectAll', function(val) {
            $scope.selectAll = val;
        });
        $scope.$watch('selectAll', function(val) {
            state.selectAll = val;
        });

    }
])
.directive('jvSearchGrid', [
    function() {
        return {
            scope: {
                columns: '=',
                results: '=',
                selectedResults: '=',
                selectAll: '=',
                sortBy: '=',
                order: '=',
                onSort: '&',
                otherApplications: '&',
                bulkActions:'=',
                bulkActionCallback:'&',
                layout: '=',
                onViewResume: '&',
                perms: '='
            },
            controller: 'jvSearchGridController',
            templateUrl: 'directives/grid-template.html'
        };
    }
])
.filter('formatGridField', [
    '$filter',
    function($filter) {
        return function(field) {
            if (field) {
                return field.defaultValue;
            }
        };
    }
]);
